import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import TimesheetService from '../../components/timesheet/TimesheetService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle'

};

export const fetchBooksContact = createAsyncThunk('booksContact', async () => {
    const response = await TimesheetService.getCustomers();
    return response;
});

export const BooksContactSlice = createSlice({
    name: 'booksContact',
    initialState,
    reducers: {
        addContactConfig: (state, action) => {
            const configs = action.payload;
            const configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToContactConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBooksContact.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchBooksContact.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })

    }
});


export const selectBooksContact = (state) => state.booksContact.data;
